export default __webpack_public_path__ + "static/media/burjeel-phone-receiver.c50ee2e3.svg";